/** The subapp a page or feature event belongs to, used as the module dimension value. */
export enum AnalyticsModule {
  Network = "network",
  Cert = "cert",
  Domeinen = "domeinen",
  Wireless = "wireless",
  ServiceDisruptions = "service-disruptions",
  News = "news",
}

/** Feature-event action names, kept central so reporting stays consistent. */
export enum AnalyticsAction {
  SlsRetrieval = "sls-retrieval",
  CbwExport = "cbw-export",
  SelfService = "self-service",
  InspectTicket = "inspect-ticket",
  InspectLineChart = "inspect-line-chart",
  InspectCertLog = "inspect-cert-log",
}

/** Distinguishes the kind of interaction for the {@link AnalyticsAction.InspectLineChart} action. */
export enum LineChartInteraction {
  DateChange = "date-change",
  ServiceChange = "service-change",
}

/** The SURFcert log view for the {@link AnalyticsAction.InspectCertLog} action. */
export enum CertLogView {
  SecurityScan = "security-scan",
  DnsFirewall = "dns-firewall",
}

/** The kind of interaction with a SURFcert log view. */
export enum CertLogInteraction {
  Filter = "filter",
  Sort = "sort",
  Paginate = "paginate",
}

export interface AnalyticsIdentity {
  customerName: string;
  customerId: string;
}
